<div *ngIf="board && !board.closed;else boardIsClosed">
  <board-quick-filters [preventNavFromSelector]="true" [boardInfo$]="boardInfo$"></board-quick-filters>
  <roadmap-board-detail [boardId]="board.id" [isNotGuest]="false" [forPrint]="true"></roadmap-board-detail>
</div>
<ng-template #boardIsClosed>
  Board is closed or not exist.
</ng-template>
